import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={closeSidebar}
        currentPath={location.pathname}
      />
      <div className="flex flex-col flex-1">
        <Header onMenuClick={toggleSidebar} user={user} />

        <div className="flex-1 p-4 overflow-auto bg-gray-100">
          {/* Card Container */}
          <div className="flex flex-col w-full h-full p-6 bg-white shadow-lg rounded-2xl">
            {/* Page Content */}
            <main className="flex-1 mt-4 overflow-y-auto">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
